import {
    FETCH_STATUS, FETCH_STATUS_SUCCESS, FETCH_STATUS_FAILURE,
    FETCH_CURRENT, FETCH_CURRENT_SUCCESS, FETCH_CURRENT_FAILURE,
    ACCEPT_TERMS, ACCEPT_TERMS_SUCCESS, ACCEPT_TERMS_FAILURE,
} from './TermsActionTypes';

export const fetchStatus = () => ({
    type: FETCH_STATUS,
})
export const fetchStatusSucceeded = (status) => ({
    type: FETCH_STATUS_SUCCESS,
    status,
})
export const fetchStatusFailed = (response) => ({
    type: FETCH_STATUS_FAILURE,
    response,
})

export const fetchCurrent = () => ({
    type: FETCH_CURRENT,
})
export const fetchCurrentSucceeded = (currentDocument) => ({
    type: FETCH_CURRENT_SUCCESS,
    currentDocument,
})
export const fetchCurrentFailed = (response) => ({
    type: FETCH_CURRENT_FAILURE,
    response,
})

export const acceptTerms = (termsDocumentId) => ({
    type: ACCEPT_TERMS,
    termsDocumentId,
})
export const acceptTermsSucceeded = () => ({
    type: ACCEPT_TERMS_SUCCESS,
})
export const acceptTermsFailed = (response) => ({
    type: ACCEPT_TERMS_FAILURE,
    response,
})
